import ActionTypes from '../constants/ActionTypes';

export const getPodBasedEvaluationDetails = solutionSlug => ({
  type: ActionTypes.GET_POD_BASED_EVALUATION_DETAILS,
  solutionSlug,
});

export const getPodBasedCurrentEvaluationId = solutionSlug => ({
  type: ActionTypes.GET_POD_BASED_CURRENT_EVALUATION_ID,
  solutionSlug,
});

export const runPodBasedTestProject = solutionSlug => ({
  type: ActionTypes.RUN_POD_BASED_TEST_PROJECT,
  solutionSlug,
});

export const getPodBasedEvaluationLog = logUrl => ({
  type: ActionTypes.GET_POD_BASED_EVALUATION_LOG,
  logUrl,
});

export const resetIsLogContentLengthAvailable = () => ({
  type: ActionTypes.RESET_IS_LOG_CONTENT_LENGTH_AVAILABLE,
});

export const setPodBasedEvaluationStateLoading = () => ({
  type: `${ActionTypes.SET_POD_BASED_EVALUATION_STATE}_LOADING`,
});

export const setPodBasedEvaluationStateEvaluating = () => ({
  type: `${ActionTypes.SET_POD_BASED_EVALUATION_STATE}_EVALUATING`,
});

export const setPodBasedEvaluationStateEvaluated = () => ({
  type: `${ActionTypes.SET_POD_BASED_EVALUATION_STATE}_EVALUATED`,
});

export const initiatePodBasedEvaluation = payload => ({
  type: ActionTypes.INITIATE_POD_BASED_EVALUATION,
  payload,
});

export const updatePodBasedTestState = payload => ({
  type: `${ActionTypes.SET_POD_BASED_TESTPROJECTSTATES}_UPDATE`,
  payload,
});

export const getTestProjectDisabledSlugs = () => ({
  type: ActionTypes.GET_TEST_PROJECT_DISABLED_SLUGS,
});
